<template>
  <q-layout view="hHh lpR fFf">
    <q-toggle v-model="value" @input="v => f(v)" />Show all Orders (Packed and Sent)
  <div class="q-pa-md">
    <q-table
      :data="orders"
      :columns="orderColumns"
      row-key="orderNumber"
      :loading="loadingOrders"
      dense
    >

        <template v-slot:body="props">
        <q-tr :props="props" @click="v => goToOrder(props)">
            <q-td key="orderNumber" :props="props">
                {{props.row.orderNumber}}
            </q-td>
            <!-- <q-td key="name" :props="props">
                {{props.row.name}}
            </q-td> -->
            <q-td key="account" :props="props">
                <template v-if="props.row.account.companyName">
                {{props.row.account.companyName}}
                </template>
                <template v-else-if="props.row.account.contactName">
                {{props.row.account.contactName}}
                </template>                
            </q-td>
            <q-td key="paid" :props="props">
                <template v-if="props.row.paid">
                <span style="color:green; font-weight: bold">PAID</span>
                </template>
                <template v-else>
                <span style="color:red; font-weight: bold">UNPAID</span>
                </template>                          
            </q-td>                                      
        </q-tr>          
        </template>
    </q-table>
  </div>    
<q-btn color="primary" icon="check" label="OK" @click="loadOrders" />
  </q-layout>
</template>

<script>
import { mount } from '@vue/test-utils';
import gql from 'graphql-tag'
export default {
  name: 'scan_order',
  data(){
    return {
        stockOrders:"",
        retailOrders:"",
        orders:[],
        loadingOrders: true,
        value: false,
        orderColumns: [
            { name: 'orderNumber', label: 'Order', align: 'left', field: "orderNumber", sortable: true},
            { name: 'account', label: 'Customer', align: 'left', field: "account", sortable: true },
            { name: 'paid', label: 'Paid', align: 'left', field: "paid", sortable: true },
                                
        ]
    }  
  },
  async mounted(){
    this.loadOrders();
  },
  methods:{
    goToOrder(props){
        this.$router.push({ path: `/scan/order/${props.row.id}` })  
    },
    f(v){
        this.loadOrders(v)
    },
    async loadOrders(showAll=false){
        this.orders=[];
        this.loadingOrders = true;
        const retailO = await  this.getRetailOrders();
        const stockO = await this.getStockOrders();
        Promise.all([retailO, stockO]).then((values) => {
            let orders = []
            for(let orderType of values){
                orders.push(...orderType)
            }
            orders.sort(function(a,b){return new Date(b.placed) - new Date(a.placed)});
            
            if(!showAll){
                for(let order of orders){
                    if(!order.packed){
                        this.orders.push(order)
                    }
                }
            }else{
            this.orders = orders;
            }
            this.loadingOrders = false;
        });   
    },    
    async getStockOrders(){
      try {
        const result = await this.$apollo.query({
          query: gql`query orders {
            orders {
            id
            orderNumber
            name
            notes
            account {
                id
                companyName
            }
            placed
            verified
            paid
            packed
            shipped
            delivered
            createdAt
            updatedAt
            totalCost
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        this.stockOrders = result.data.orders;
        return result.data.orders;
      } catch (error) {
        throw new Error(error);    
      }        
    },
    async getRetailOrders(){
      try {
        const result = await this.$apollo.query({
          query: gql`query orders {
            retailOrders {
            id
            orderNumber
            name
            notes
            account {
                id
                contactName
            }
            placed
            verified
            paid
            packed
            shipped
            delivered
            createdAt
            updatedAt
            totalCost
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        this.retailOrders = result.data.retailOrders;
        return result.data.retailOrders;
      } catch (error) {
        throw new Error(error);    
      }          
    }
  }
}
</script>

<style lang="stylus" scoped>
.scroll_content::-webkit-scrollbar {
    display: none;
}
.scroll_content{
    padding: 0 5px;
}

</style>